import { Outlet, ScrollRestoration } from "react-router-dom";
import { Footer } from "./Footer";
import { TopNav } from "./TopNav";

export const MarketingLayout = () => (
  <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    {/* Reset scroll to top on every new in-SPA navigation (TopNav links,
        Footer links, Link in body content). React Router preserves scroll on
        back/forward automatically when this is mounted under createBrowserRouter. */}
    <ScrollRestoration />
    <TopNav />
    <main style={{ flex: 1 }}>
      <Outlet />
    </main>
    <Footer />
  </div>
);
